import { UpdateOrganizationMutation } from "#src/api/Organization.ts";
import { BorderButton } from "#src/components/buttons/BorderButton.tsx";
import { OrganizationModel } from "#src/models/OrganizationModel.ts";
import { apiClient } from "#src/stores/Api.tsx";
import { useStore } from "#src/stores/Store.tsx";
import tw from "#src/utils/tw.ts";
import type { updateOrganizationVariables } from "#types/code-generator.ts";

interface Props {
  menu?: boolean;
}

export function TerminalBanner(props: Props) {
  const store = useStore();

  async function dismissTerminalBanner() {
    const variables: updateOrganizationVariables = {
      data: {
        upgradeTerminal: {
          update: {},
        },
      },
      where: {
        id: store.organization.id,
      },
    };

    if (props.menu) {
      variables.data.upgradeTerminal.update.showMenuBanner = false;
    } else {
      variables.data.upgradeTerminal.update.showAdminBanner = false;
    }

    const updatedOrganization = await apiClient(UpdateOrganizationMutation, {
      variables,
    });

    store.setOrganization(
      new OrganizationModel(updatedOrganization.updateOrganization)
    );
  }

  if (
    !props.menu &&
    store.organization.upgradeTerminal?.showAdminBanner === false
  ) {
    return null;
  }

  if (
    props.menu &&
    store.organization.upgradeTerminal?.showMenuBanner === false
  ) {
    return null;
  }

  return (
    <div className="relative">
      <div
        className={tw(
          "bg-dark flex h-60 items-center overflow-hidden rounded-md text-white sm:h-auto sm:flex-col sm:gap-6 sm:py-6",
          props.menu && "py-4 h-auto"
        )}
      >
        <div className="flex-1 px-6 text-center">
          <div className="text-main font-bold">Coming soon</div>
          <h1>
            <strong>In-person payments</strong>
          </h1>
          <p className="text-white">
            Accept payments on-site with mobile terminals for admissions,
            concessions, parking, apparel, events, and more.
          </p>

          <BorderButton type="submit" to={`/admin/account/plan/terminal`}>
            Tell Us You’re Interested
          </BorderButton>
        </div>

        {!props.menu && (
          <div className="border-action -my-6 -mr-24 flex-1 -skew-x-[30deg] overflow-hidden border-l-8 sm:mt-0 sm:skew-0 sm:border-t-8 sm:border-l-0">
            <img
              src="/img/terminal/1.jpg"
              alt="Terminal"
              className="h-full w-full origin-right scale-150 skew-x-[30deg] object-cover sm:skew-0"
            />
          </div>
        )}
      </div>
      <button
        type="button"
        className="absolute top-4 right-4 text-white"
        onClick={dismissTerminalBanner}
      >
        <i className="far fa-xmark" />
      </button>
    </div>
  );
}
